module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/upsellBg-04a191593edc2f38fe52608da326b6d8.png";